<ng-container *ngIf="packages?.length > 0" >

  <red-payment-package
    *ngFor="let item of packages; let index = index"
    class="c-pricing-table"
    [class.c-pricing-table--featured]="item.destaque"
    [package]="item"
    (couponApplied)="couponAppliedAction($event, item)"
    (packageAction)="action($event)">
  </red-payment-package>

</ng-container>
